import { Box, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { useField } from 'react-final-form';
import { FieldCheckbox, TypographyWrapper, ValidationError } from '../../components';
import * as validators from '../../util/validators';
import Heading from './Heading';
import { ListingFlowFormField } from './ListingFlowTypes';
import { useTradeInConfig } from '../../hooks/useTradeInConfig';

const DEFAULT_LISTING_ACKNOWLEDGEMENT_COPY = [
  'The item is the correct item indicated.',
  'If the item is different than indicated, I may not receive credit for this item.',
  'The item cannot be returned to me once shipped.',
];

const AcknowledgementCopy: FC = () => {
  const { listingAcknowledgementCopy } = useTradeInConfig();

  return (
    <ol style={{ paddingInlineStart: 'unset', listStyle: 'decimal inside' }}>
      <TypographyWrapper variant="body1">
        {(listingAcknowledgementCopy || DEFAULT_LISTING_ACKNOWLEDGEMENT_COPY).map(
          (line: string) => (
            <li style={{ fontFamily: 'inherit', fontSize: 'inherit' }}>{line}</li>
          )
        )}
      </TypographyWrapper>
    </ol>
  );
};

const AcknowledgementCheckbox: FC = () => {
  const { meta } = useField(ListingFlowFormField.Acknowledgement);

  return (
    <>
      <Heading>Acknowledgement</Heading>
      <Box mt={1}>
        <AcknowledgementCopy />
        <ValidationError fieldMeta={meta} />
        <FieldCheckbox
          id={ListingFlowFormField.Acknowledgement}
          name={ListingFlowFormField.Acknowledgement}
          label={
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              I agree to the terms above.
            </Typography>
          }
          value="true"
          validate={validators.requiredFieldArrayCheckbox('Agreement is required.')}
        />
      </Box>
    </>
  );
};
export default AcknowledgementCheckbox;
